import React from 'react';
import { Star } from 'lucide-react';

export default function StarRating({ value = 0, onChange, size = 'md', readOnly = false }) {
  const sizes = { sm: 'w-4 h-4', md: 'w-6 h-6', lg: 'w-8 h-8' };
  const s = sizes[size] || sizes.md;

  return (
    <div className="flex items-center gap-1" data-testid="star-rating">
      {[1, 2, 3, 4, 5].map(star => (
        <button
          key={star}
          type="button"
          disabled={readOnly}
          onClick={() => onChange?.(star)}
          className={`transition-all duration-200 ${readOnly ? 'cursor-default' : 'cursor-pointer hover:scale-110'}`}
          data-testid={`star-${star}`}
        >
          <Star
            className={`${s} ${star <= value ? 'fill-amber-400 text-amber-400' : 'fill-none text-border'}`}
            strokeWidth={1.5}
          />
        </button>
      ))}
    </div>
  );
}

export function StarDisplay({ value, size = 'sm' }) {
  if (!value || value === 0) return null;
  const sizes = { xs: 'w-3 h-3', sm: 'w-3.5 h-3.5', md: 'w-4 h-4' };
  const s = sizes[size] || sizes.sm;
  return (
    <div className="flex items-center gap-0.5">
      {[1, 2, 3, 4, 5].map(star => (
        <Star
          key={star}
          className={`${s} ${star <= Math.round(value) ? 'fill-amber-400 text-amber-400' : 'fill-none text-border'}`}
          strokeWidth={1.5}
        />
      ))}
      <span className="text-xs text-muted-foreground font-sans ml-1">{value.toFixed?.(1) || value}</span>
    </div>
  );
}
